var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: (_vm.prefixCls + "-carousel " + _vm.prefixCls + "-slide")
  }, [_c('ol', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indicators),
      expression: "indicators"
    }],
    class: (_vm.prefixCls + "-carousel-indicators")
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.indicator), function(i, index) {
    return _c('li', {
      key: index,
      class: [index === _vm.activeIndex ? _vm.prefixCls + '-carousel-active' : ''],
      on: {
        "click": function($event) {
          _vm.handleIndicatorClick(index)
        }
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    class: (_vm.prefixCls + "-carousel-inner")
  }, [_vm._t("default")], 2), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.controls),
      expression: "controls"
    }],
    class: (_vm.prefixCls + "-carousel-left " + _vm.prefixCls + "-carousel-control"),
    on: {
      "click": _vm.prevClick
    }
  }, [_c('n3-icon', {
    attrs: {
      "type": "chevron-left"
    }
  })], 1), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.controls),
      expression: "controls"
    }],
    class: (_vm.prefixCls + "-carousel-right " + _vm.prefixCls + "-carousel-control"),
    on: {
      "click": _vm.nextClick
    }
  }, [_c('n3-icon', {
    attrs: {
      "type": "chevron-right"
    }
  })], 1)])
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-3cc2a44c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cc2a44c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Carousel/n3Carousel.vue
// module id = 616
// module chunks = 0 1